/**
 * @generated SignedSource<<b4f221f21a14cd07e8f2b83cfd9d6457>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrandMessageStatusEnum = "A" | "S" | "%future added value";
export type ChatBubbleTypeEnum = "CAROUSEL_COMMERCE" | "CAROUSEL_FEED" | "COMMERCE" | "IMAGE" | "PREMIUM_VIDEO" | "TEXT" | "WIDE" | "WIDE_ITEM_LIST" | "%future added value";
export type BrandMessageTemplateUpdateInput = {
  additionalContent?: string | null;
  adult: boolean;
  buttons?: ReadonlyArray<BrandMessageButtonInput> | null;
  carousel?: BrandMessageCarouselInput | null;
  chatBubbleType: ChatBubbleTypeEnum;
  commerce?: BrandMessageCommerceInput | null;
  content?: string | null;
  coupon?: BrandMessageCouponInput | null;
  header?: string | null;
  image?: Upload | null;
  imageLink?: string | null;
  imageUrl?: string | null;
  mainWideItem?: BrandMessageWideItemInput | null;
  subWideItemList?: ReadonlyArray<BrandMessageWideItemInput> | null;
  templateCode: string;
  templateName: string;
  video?: Upload | null;
  videoId?: string | null;
};
export type BrandMessageButtonInput = {
  bizFormId?: string | null;
  linkAndroid?: string | null;
  linkIos?: string | null;
  linkMobile?: string | null;
  linkPc?: string | null;
  linkType: string;
  name: string;
  ordering?: number | null;
};
export type BrandMessageCarouselInput = {
  head?: BrandMessageCarouselHeadInput | null;
  list: ReadonlyArray<BrandMessageCarouselItemInput>;
  tail?: BrandMessageLinkInput | null;
};
export type BrandMessageCarouselHeadInput = {
  content?: string | null;
  header?: string | null;
  image?: Upload | null;
  imageUrl?: string | null;
  linkAndroid?: string | null;
  linkIos?: string | null;
  linkMobile?: string | null;
  linkPc?: string | null;
};
export type Upload = {
  fieldName?: string | null;
  key: string;
  multipartUploadResult?: MultiPartUploadResult | null;
  objectUrl?: string | null;
  size: number;
};
export type MultiPartUploadResult = {
  partPairs: ReadonlyArray<PartPair>;
  uploadId: string;
};
export type PartPair = {
  ETag: string;
  PartNumber: number;
};
export type BrandMessageCarouselItemInput = {
  additionalContent?: string | null;
  buttons?: ReadonlyArray<BrandMessageButtonInput> | null;
  commerce?: BrandMessageCommerceInput | null;
  content?: string | null;
  coupon?: BrandMessageCouponInput | null;
  header?: string | null;
  image?: Upload | null;
  imageLink?: string | null;
  imageUrl?: string | null;
};
export type BrandMessageCommerceInput = {
  discountFixed?: number | null;
  discountPrice?: number | null;
  discountRate?: number | null;
  regularPrice?: number | null;
  title: string;
  usePriceVariable: boolean;
};
export type BrandMessageCouponInput = {
  description: string;
  linkAndroid?: string | null;
  linkIos?: string | null;
  linkMobile?: string | null;
  linkPc?: string | null;
  title: string;
};
export type BrandMessageLinkInput = {
  linkAndroid?: string | null;
  linkIos?: string | null;
  linkMobile?: string | null;
  linkPc?: string | null;
};
export type BrandMessageWideItemInput = {
  image?: Upload | null;
  imageUrl?: string | null;
  linkAndroid?: string | null;
  linkIos?: string | null;
  linkMobile?: string | null;
  linkPc?: string | null;
  title: string;
};
export type BrandMessageTemplateUpdateDialog_brandMessageTemplateUpdateMutation$variables = {
  input: BrandMessageTemplateUpdateInput;
};
export type BrandMessageTemplateUpdateDialog_brandMessageTemplateUpdateMutation$data = {
  readonly brandMessageTemplateUpdate: {
    readonly id: string;
    readonly parameterNames: ReadonlyArray<string>;
    readonly serviceStatus: BrandMessageStatusEnum;
    readonly updateTime: any | null;
    readonly " $fragmentSpreads": FragmentRefs<"BrandMessageTemplateUpdateDialog_brandMessageTemplate">;
  };
};
export type BrandMessageTemplateUpdateDialog_brandMessageTemplateUpdateMutation = {
  response: BrandMessageTemplateUpdateDialog_brandMessageTemplateUpdateMutation$data;
  variables: BrandMessageTemplateUpdateDialog_brandMessageTemplateUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parameterNames",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updateTime",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceStatus",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkIos",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkMobile",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkPc",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkAndroid",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BrandMessageTemplateUpdateDialog_brandMessageTemplateUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandMessageTemplate",
        "kind": "LinkedField",
        "name": "brandMessageTemplateUpdate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BrandMessageTemplateUpdateDialog_brandMessageTemplate"
          },
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BrandMessageTemplateUpdateDialog_brandMessageTemplateUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandMessageTemplate",
        "kind": "LinkedField",
        "name": "brandMessageTemplateUpdate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "templateCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "templateName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "chatBubbleType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "adult",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "imageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "imageLink",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "header",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "additionalContent",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "carousel",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "wideItemList",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "video",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "commerce",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandMessageButton",
            "kind": "LinkedField",
            "name": "buttons",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "linkType",
                "storageKey": null
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bizFormId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ordering",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandMessageCoupon",
            "kind": "LinkedField",
            "name": "coupon",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              (v9/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d665ef980fcf1b54b60e7d2f24036e3b",
    "id": null,
    "metadata": {},
    "name": "BrandMessageTemplateUpdateDialog_brandMessageTemplateUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation BrandMessageTemplateUpdateDialog_brandMessageTemplateUpdateMutation(\n  $input: BrandMessageTemplateUpdateInput!\n) {\n  brandMessageTemplateUpdate(input: $input) {\n    id\n    ...BrandMessageTemplateUpdateDialog_brandMessageTemplate\n    parameterNames\n    updateTime\n    serviceStatus\n  }\n}\n\nfragment BrandMessageTemplateUpdateDialog_brandMessageTemplate on BrandMessageTemplate {\n  templateCode\n  templateName\n  chatBubbleType\n  content\n  adult\n  imageUrl\n  imageLink\n  header\n  additionalContent\n  carousel\n  wideItemList\n  video\n  commerce\n  buttons {\n    name\n    linkType\n    linkIos\n    linkMobile\n    linkPc\n    linkAndroid\n    bizFormId\n    ordering\n  }\n  coupon {\n    description\n    linkAndroid\n    linkIos\n    linkMobile\n    linkPc\n    title\n  }\n}\n"
  }
};
})();

(node as any).hash = "1ed399ecaab0034bbe0fc465d944d381";

export default node;
